@for (btn of buttonItems; track btn.icon; let i = $index) {
  <button
    [class]="'action-button ' + (btn.class ? btn.class : 'btn-plain')"
    attr.aria-label="{{ !btn.label ? ('ARIA.' + btn.icon | translate) : undefined }}"
    [attr.icon-type]="btn.icon"
    (click)="onActionClick($event, btn)"
  >
    @if (btn.icon === actions.BOOKMARK && isBookmarked) {
      <ng-container *ngTemplateOutlet="iconTpl; context: { icon: 'bookmark-flat' }"></ng-container>
    } @else {
      <ng-container *ngTemplateOutlet="iconTpl; context: { icon: btn.icon }"></ng-container>
    }
    @if (btn.label) {
      <span class="action-label" [ngClass]="btn.labelClass || ''">{{ btn.label | translate }}</span>
    }
  </button>
}
<ng-template #iconTpl let-icon="icon">
  <span class="icon mb-icon-{{ icon }} mb-icon"></span>
</ng-template>
